import CompanyVipApp from './CompanyVipApp';
import React from 'react';
import {Redirect} from 'react-router-dom';
import {authRoles} from "../../../../store/actionreducers/auth/auth";

export const CompanyVipAppConfig = {
    auth: authRoles.admin,
    routes: [
        {
            path: '/apps/company/vip/:id',
            component: CompanyVipApp
        },
        {
            path: '/apps/company/vip',
            component: () => <Redirect to="/apps/company/vip/all"/>
        }
    ]
};



// WEBPACK FOOTER //
// ./src/main/content/callHelper/companyVip/CompanyVipAppConfig.js